/* eslint-disable @typescript-eslint/no-namespace */
import z from "zod";

const NameSchema = z.string().trim().min(1, "Name: Invalid name.").brand<"Name">();

/**
 * A name is a string that represents a non-empty name, e.g. for a person or company.
 */
export type Name = z.infer<typeof NameSchema>;

export namespace Name {
    // Type guard overloads to allow for optional names
    export function create(value: string): Name;
    export function create(value: undefined | null): undefined;
    export function create(value: string | undefined | null): Name | undefined;

    /**
     * Creates a new name.
     *
     * @param value The value to create the name from.
     * @returns The new name.
     * @throws An error if the name is empty.
     */
    export function create(value: string | undefined | null): Name | undefined {
        if (value === undefined || value === null) {
            return undefined;
        }
        return NameSchema.parse(value);
    }
}
